import React, { Component } from 'react';
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBCard,
    MDBCardBody,
    MDBBtn,
} from "mdbreact";
import Select from 'react-select'

class Report_Pendaftaran_pusat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            CB_STUDYYEAR: '',
            CB_REGTYPE: '',
            CB_JALUR: '',
            CB_FLOW: '',
            val_jalur: '',
            val_studyyear: '',
            valueYear: '',
            valueStatus: '',
            is_show: false,
            valueDataUnit: {},
        }
    }

    componentDidMount() {
        fetch(global.variable.LINK_API + 'auth/parameter',
            {
                method: 'get',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                },
            })
            .then(response => response.json())
            .then(resData => {
                if (resData.message === "Success") {
                    let dataFlow = resData.data.prm_flow;
                    let resFlow = [];
                    if (dataFlow != null) {
                        resFlow = JSON.parse(dataFlow.flow);
                    }
                    this.setState({ CB_FLOW: resFlow, CB_STUDYYEAR: resData.data.prm_study_year });
                    localStorage.setItem('DATA_PARAMETER', JSON.stringify(resData.data));
                }
            })
        this.fetchDataUnit();
    }

    async fetchDataUnit() {
        var dataUnit = JSON.parse(localStorage.getItem('DATA_PARAMETER')).prm_unit;
        await fetch(global.variable.LINK_API + 'unit/list-by-organizations', {
            method: "post",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + global.cookies.get("access_token"),
            },
            body: JSON.stringify({
                org_id: dataUnit.organizations_id,
            })
        })
            .then((response) => response.json())
            .then((resData) => {
                if (resData.code === 200) {
                    this.setState({ valueDataUnit: resData.data });
                }
            });
    }

    createSelectItems() {
        let items = [];
        for (let i = 0; i < this.state.CB_JALUR.length; i++) {
            items.push(<option key={i} value={this.state.CB_JALUR[i].id + '-' + this.state.CB_JALUR[i].fullname}>{this.state.CB_JALUR[i].id + ' - ' + this.state.CB_JALUR[i].fullname}</option>);
        }
        return items;
    }

    createSelectItemsStudyYear() {
        let items = [];
        for (let i = 0; i < this.state.CB_STUDYYEAR.length; i++) {
            items.push(
                {
                    value: this.state.CB_STUDYYEAR[i].id,
                    label: this.state.CB_STUDYYEAR[i].name
                }
            );
        }
        return <Select options={items} isClearable onChange={e => this.onDropdownSelected2('valueYear', e)} placeholder="- Pilih Tahun -" />;
    }

    getMaster(id = '') {
        var array = JSON.parse(localStorage.getItem("DATA_PARAMETER")).pdf_flow;
        var arrayfilter = array.filter((data) => { if (data.id == id) return data });
        var name = arrayfilter[0].name || '';
        return name;
    }

    createSelectUnit() {
        let items = [];
        var data = this.state.valueDataUnit;
        for (let i = 0; i < data.length; i++) {
            items.push(
                {
                    value: data[i].subdomain,
                    label: data[i].name
                }
            );
        }
        return <Select options={items} isClearable onChange={e => this.onDropdownSelected2('valueUnit', e)} placeholder="- Pilih Unit -" />;
    }

    createSelectItemsFlow() {
        let items = [];
        items.push({
            value: "",
            label: "Semua Status",
        })
        for (let i = 0; i < this.state.CB_FLOW.length; i++) {
            items.push(
                {
                    value: this.state.CB_FLOW[i],
                    label: this.getMaster(this.state.CB_FLOW[i])
                }
            );
        }
        items.push({
            value: "REJ",
            label: "Tidak Diterima",
        })
        return <Select options={items} isClearable onChange={e => this.onDropdownSelected2('valueStatus', e)} placeholder="- Semua Status -" />;
    }

    onDropdownSelected2(name, e) {
        const value = e ? e.value : {};
        this.setState({ [name]: value });
    }

    handleSubmit = event => {
        event.preventDefault();

        let params = '';
        if (this.state.valueUnit !== '') {
            params += this.state.valueUnit + '/' + this.state.valueYear + '/' + this.state.valueStatus;
        }

        localStorage.setItem('pusat_data', JSON.stringify(params));
        this.props.history.push("/reportpendaftaranpusatdetail")
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">

                                <div className="divContainter">
                                    <MDBCard className="mb-5">
                                        <MDBCardBody>
                                            <MDBBreadcrumb color="cyan lighten-4">
                                                <MDBBreadcrumbItem active>
                                                    <a href="/home">Home</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    Laporan Pendaftaran Pusat
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>

                                            <form onSubmit={this.handleSubmit}>
                                                <div className="form-group">
                                                    <label htmlFor="exampleForm2">Pilih Unit <span style={{ color: 'red' }}>*</span></label>
                                                    {this.createSelectUnit()}
                                                </div>
                                                <div className='form-group'>
                                                    <label htmlFor="exampleForm2">Pilih Tahun</label>
                                                    {this.createSelectItemsStudyYear()}
                                                </div>
                                                <div className='form-group'>
                                                    <label htmlFor="exampleForm2">Pilih Status</label>
                                                    {this.createSelectItemsFlow()}
                                                </div>
                                                <MDBBtn color="primary" block type="submit">
                                                    lanjut
                                                </MDBBtn>
                                            </form>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Report_Pendaftaran_pusat;